import type { Credential } from '@/types';

export interface MisconfiguredConnector {
  credentialType: string;
  count: number;
}

/**
 * Validates connectors and returns misconfigured types.
 * A connector type is misconfigured if:
 * 1. There are multiple credentials of the same type AND none have defaultConnection=true
 * 2. There is a single credential of the type AND it does NOT have defaultConnection=true
 *
 * Matches dataProtect/src/components/environments/Connector.js lines 111-127
 */
export const validateConnectors = (credentials: Credential[]): MisconfiguredConnector[] => {
  const misconfiguredConnectors: MisconfiguredConnector[] = [];
  const credentialTypes: string[] = [];

  // Collect all unique credential types (excluding LocalFile and EnvironmentVariables)
  credentials.forEach((cred) => {
    if (cred.credentialType === 'LocalFile' || cred.credentialType === 'EnvironmentVariables') {
      return;
    }
    if (!credentialTypes.includes(cred.credentialType)) {
      credentialTypes.push(cred.credentialType);
    }
  });

  // Check each type for misconfiguration
  for (const type of credentialTypes) {
    const isDefault: number[] = [];

    for (const cred of credentials) {
      if (type === cred.credentialType) {
        isDefault.push(cred.defaultConnection ? 1 : 0);
      }
    }

    // Misconfigured Case 1: Single credential without default connection
    if (isDefault.length === 1 && isDefault.includes(0)) {
      misconfiguredConnectors.push({
        credentialType: type,
        count: 1,
      });
    }

    // Misconfigured Case 2: Multiple credentials with no default connection
    if (!isDefault.includes(1) && isDefault.length > 1) {
      misconfiguredConnectors.push({
        credentialType: type,
        count: isDefault.length,
      });
    }
  }

  return misconfiguredConnectors;
};
